import { TbArrowDown } from 'react-icons/tb';
import { useTranslate } from '@tolgee/react';

type OrderButtonProps = {
  children: string;
  rightAddon?: React.ReactNode;
  as?: 'button' | 'span';
  direction?: 'asc' | 'desc';
  disabled?: boolean;
  full?: boolean;
  onClick?: () => void;
  className?: string;
};

export function OrderButton({
  children,
  as: Component = 'button',
  direction = 'asc',
  disabled = false,
  full = false,
  rightAddon,
  className = '',
  onClick
}: OrderButtonProps) {
  const { t } = useTranslate('default');

  const getButtonTitle = () => {
    return t('common.order_by', {
      field: children,
      direction: t(
        `common.${direction === 'asc' ? 'descending' : 'ascending'}`
      ).toLowerCase()
    });
  };

  const baseClasses =
    'appearance-none border-0 bg-transparent text-inherit font-inherit cursor-pointer transition-all whitespace-pre flex items-center gap-2 justify-center';
  const disabledClasses = 'disabled:opacity-50 disabled:cursor-not-allowed';
  const fullClasses = full ? 'w-full' : '';
  const textClasses = Component === 'span' ? 'cursor-default' : '';
  const rotateClasses = direction === 'desc' ? 'rotate-0' : 'rotate-180';

  return (
    <Component
      type={Component === 'button' ? 'button' : undefined}
      disabled={Component === 'button' ? disabled : undefined}
      title={Component === 'button' ? getButtonTitle() : undefined}
      onClick={Component === 'button' ? onClick : undefined}
      className={`${baseClasses} ${disabledClasses} ${fullClasses} ${textClasses} ${className}`}>
      {children}
      {!disabled && Component === 'button' && (
        <TbArrowDown
          id="order-icon-arrow"
          size={16}
          style={{ flexShrink: 0 }}
          className={`transition-transform ${rotateClasses}`}
        />
      )}
      {rightAddon || null}
    </Component>
  );
}
